/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { Constants } from '../../../constants/constants';
import { TipoDocumentoDto } from '../../../dto/expediente/tipo-documento.dto';
import { ListasService } from '../../../services/listas.service';
import { RecaptchaService } from '../../../services/util/recaptcha.service';
import { passwordMatchValidator } from '../validaciones/password-match.validator';
import { format } from 'date-fns';
import { UsuarioService } from '../../../services/usuario.service';
import { UsuarioDto } from '../../../dto/usuario/usuario.dto';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { AutenticacionService } from '../services/autenticacion.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PaisDto } from "../../../dto/expediente/pais.dto";
import { DepartmentoDto } from "../../../dto/expediente/departmento.dto";
import { MunicipioDto } from '../../../dto/expediente/municipio.dto';
import { ModalTerminosComponent } from '../modal-terminos/modal-terminos.component';
import { ModalService } from '../../../services/util/modal.service';
import { take } from 'rxjs';
import { TerminosCondicionesService } from '../../../services/terminos-condiciones.service';
import { TerminosCondicionesResponseDto } from '../../../dto/auth/terminos-condiciones.dto';
import { Location } from '@angular/common';
@Component({
  selector: 'app-registry',
  templateUrl: './registry.component.html',
  styleUrl: './registry.component.scss',
})
export class RegistryComponent implements OnInit {
  @ViewChild(ModalTerminosComponent)
  modalTerminos!: ModalTerminosComponent;

  public crearUsuarioForm!: FormGroup;
  public tipoUsuarioForm!: FormGroup;
  // Listas
  public tiposDocumento: TipoDocumentoDto[] = [];
  paises: PaisDto[] = [];
  departamentos: DepartmentoDto[] = [];
  municipios: MunicipioDto[] = [];

  // Boolean
  public showForm = false;
  public isLawyer = false;
  public isCivicPerson = false;
  esColombia = true;

  // Nueva bandera para alternar entre formulario y video
  public showVideoSection = false;
  // Nueva bandera para alternar entre formulario y términos
  public showTermsSection = false;
  // Banderas para checkboxes de términos
  public acceptedPrivacy = false;
  public acceptedTerms = false;

  recaptchaToken: string | null = null;
  allowedType: 'numbers' | 'alphanumeric' = 'numbers';
  maxLengthIdentificacion = 12;
  anioActual: number;

  tipoUsuario = [
    {
      idTipoUsuario: 2,
      value: 'Ciudadano',
    },
    {
      idTipoUsuario: 1,
      value: 'Abogado',
    },
  ];

  // Terminos y condiciones
  terms: TerminosCondicionesResponseDto | null = null;

  dataDigital: any = undefined;

  ingresaPorDigital = false;

  // Multilenguaje
  registryText: any = {};
  constructor(
    private fb: FormBuilder,
    private listasService: ListasService,
    private recaptchaService: RecaptchaService,
    private usuarioService: UsuarioService,
    private alertaModalService: AlertaModalService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private autenticacionService: AutenticacionService,
    private router: Router,
    private readonly translate: TranslateService,
    private modalService: ModalService,
    private readonly terminosCondicionesService: TerminosCondicionesService,
    private location: Location
  ) {
    this.anioActual = new Date().getFullYear();
    if (history.state?.primerNombreDigital) {
      this.ingresaPorDigital = true;
      type TipoDocumento = keyof typeof Constants.TIPOS_DOCUMENTOS;
      const tipo = history.state.tipoDocumentoDigital as TipoDocumento;
      const tipoDocumentoDigital = Constants.TIPOS_DOCUMENTOS[tipo];
      this.dataDigital = {
        primerNombreDigital: history.state.primerNombreDigital,
        segundoNombreDigital: history.state.segundoNombreDigital,
        primerApellidoDigital: history.state.primerApellidoDigital,
        segundoApellidoDigital: history.state.segundoApellidoDigital,
        correoElectronicoDigital: history.state.correoElectronicoDigital,
        telefonoPrincipalDigital: history.state.telefonoPrincipalDigital,
        correoDigital: history.state.correoDigital,
        tipoDocumentoDigital: tipoDocumentoDigital,
        identificacionDigital: history.state.identificacionDigital,
        direccionDigital: history.state.direccionDigital,
        usernameDigital: history.state.usernameDigital,
        usuarioId: history.state.usuarioId
      }
      setTimeout(() => {
        this.crearUsuarioForm.patchValue({
          tipo_documento: tipoDocumentoDigital ?? '',
        })
      }, 4000);
    } else {
      this.ingresaPorDigital = false;
    }
    this.buildForm();
    this.autenticacionService.logout();
  }

  ngOnInit(): void {
    this.translate.stream('registry').forEach(text => {
      for (const key of Object.keys(text)) {
        this.registryText[key] = text[key];
      }
    });
    this.getTiposDocumento();
    // Se obtiene la lista de países
    this.listarPaises();
    // Se obtiene la lista de términos y condiciones
    this.getTerminosYCondiciones();
  }

  buildForm() {
    this.crearUsuarioForm = this.fb.group(
      {
        primer_nombre: [
          {
            value: this.dataDigital?.primerNombreDigital ?? '',
            disabled: this.dataDigital !== undefined
          },
          [
            Validators.required,
            Validators.pattern(
              Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT
            ),
            Validators.minLength(2)
          ],
        ],
        segundo_nombre: [
          {
            value: this.dataDigital?.segundoNombreDigital ?? '',
            disabled: this.dataDigital !== undefined
          },
          [
            Validators.pattern(
              Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT
            ),
            Validators.minLength(2)
          ],
        ],
        primer_apellido: [
          {
            value: this.dataDigital?.primerApellidoDigital ?? '',
            disabled: this.dataDigital !== undefined
          },
          [
            Validators.required,
            Validators.pattern(
              Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT
            ),
            Validators.minLength(2)
          ],
        ],
        segundo_apellido: [
          {
            value: this.dataDigital?.segundoApellidoDigital ?? '',
            disabled: this.dataDigital !== undefined
          },
          [
            Validators.pattern(
              Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT
            ),
            Validators.minLength(2)
          ],
        ],
        tipo_documento: [
          {
            value: this.dataDigital?.tipoDocumentoDigital ?? '',
            disabled: this.dataDigital !== undefined
          },
          [Validators.required],
        ],
        numero_documento: [
          {
            value: this.dataDigital?.identificacionDigital ?? '',
            disabled: this.dataDigital !== undefined
          },
          [
            Validators.required,
            Validators.pattern(Constants.REGEX_ALFANUMERICO_VALIDATION),
          ],
        ],
        fecha_nacimiento: [
          '',
          [Validators.required, this.edadMinimaValidator(18)],
        ],
        nacionalidad: [],
        pais: ['', [Validators.required]],
        departamento: ['', [Validators.required]],
        municipio: ['', [Validators.required]],
        direccion: [
          {
            value: this.dataDigital?.direccionDigital ?? '',
            disabled: this.dataDigital !== undefined
          },
          [
            Validators.required,
            Validators.minLength(10),
            Validators.maxLength(30),
            Validators.pattern(Constants.REGEX_ADDRESS)],
        ],
        telefono: [
          {
            value: this.dataDigital?.telefonoPrincipalDigital ?? '',
            disabled: this.dataDigital !== undefined
          },
          [
            Validators.required,
            Validators.minLength(7),
            Validators.maxLength(10),
            Validators.pattern(Constants.REGEX_TELEFONO)]
        ],
        otroDepartamento: ['', [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ]],
        otroMunicipio: ['', [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ]],
        correo: [
          {
            value: this.dataDigital?.correoDigital ?? '',
            disabled: this.dataDigital !== undefined
          },
          [
            Validators.required,
            Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
            Validators.maxLength(50),
          ],
        ],
        pregunta_seguridad: [
          '',
          [
            Validators.pattern(Constants.REGEX_WITHOUT_ESPACES),
            Validators.maxLength(20),
          ],
        ],
      },
    );

    this.tipoUsuarioForm = this.fb.group({
      tipoUsuario: [{ value: this.ingresaPorDigital ? Constants.TYPE_OF_PERSON_JURIDICA : Constants.TYPE_OF_PERSON_NATURAL, disabled: true }, Validators.required],
    });
    this.getIdTipoUsuario();
  }

  getIdTipoUsuario() {
    if (!this.dataDigital) {
      this.crearUsuarioForm.reset();
    }
    this.crearUsuarioForm.get('tipo_documento')?.setValue('');
    let value = this.tipoUsuarioForm.value;
    if (value.tipoUsuario) {
      this.showForm = true;
      this.isCivicPerson = value.tipoUsuario === Constants.TYPE_OF_PERSON_JURIDICA;
      this.isLawyer = value.tipoUsuario === Constants.TYPE_OF_PERSON_NATURAL;
      this.getTiposDocumento(value.tipoUsuario);
    } else {
      this.showForm = false;
      this.isCivicPerson = false;
      this.isLawyer = false;
    }

    if (this.isLawyer) {
      this.crearUsuarioForm
        .get('tarjeta_profesional')
        ?.addValidators([
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(12),
        ]);
      this.crearUsuarioForm
        .get('tarjeta_profesional')
        ?.updateValueAndValidity();
    } else {
      this.crearUsuarioForm.get('tarjeta_profesional')?.clearValidators();
      this.crearUsuarioForm
        .get('tarjeta_profesional')
        ?.updateValueAndValidity();
    }
  }

  getTiposDocumento(typeUser?: string) {
    this.listasService
      .getDocumentTypeListByPersonType('1', 0)
      .subscribe(response => {
        this.tiposDocumento = response;

        switch (typeUser) {
          case '1':
            this.tiposDocumento = this.tiposDocumento.filter(
              elemento => elemento.Id != 5 && elemento.Id != 7
            )
            break;
          case '2':
            this.tiposDocumento = this.tiposDocumento.filter(
              elemento => elemento.Id != 6 && elemento.Id != 7
            )
            break;
        }
      });
  }

  // Se consume el servicio que lista los países
  listarPaises() {
    this.listasService.getCountryList().subscribe((paises: PaisDto[]) => {
      this.paises = paises;
    });
  }
  onSubmit(action: string) {
    this.recaptchaV3Service.execute(action).subscribe((token: string) => {
      this.recaptchaService
        .verificarTokenRecaptcha({ token: token })
        .subscribe(response => {
          if (response.success == true) {
            if (this.crearUsuarioForm.valid) {
              const usuarioRequest = this.createFormData(
                this.crearUsuarioForm.getRawValue()
              );
              this.usuarioService.crearUsuario(usuarioRequest).subscribe(
                resp => {
                  if (resp.success) {
                    this.alertaModalService
                      .exito(
                        this.registryText['usuario-registrado'],
                        this.registryText['instruccion-ingreso'])
                      .then(() => {
                        this.location.back();
                      });
                  } else {
                    this.alertaModalService
                      .advertencia('Algo no ha salido bien', resp.message);
                  }
                },
                err => {
                  if (err.status == 400) {
                    this.alertaModalService.error(
                      'Error creando usuario',
                      err.error.message
                    );
                  } else {
                    this.alertaModalService.error(
                      this.registryText['error-crear-usuario-titulo'],
                      this.registryText['error-crear-usuario']
                    );
                  }
                }
              );
            }
          } else {
            this.alertaModalService.error(
              this.registryText['error-recaptcha-titulo'],
              this.registryText['error-recaptcha']
            );
          }
        });
    });
  }

  createFormData(formValue: any): UsuarioDto {

    const fechaUTC = new Date(formValue['fecha_nacimiento']);
    fechaUTC.setMinutes(fechaUTC.getMinutes() + fechaUTC.getTimezoneOffset()); // Corrige desfase de zona horaria
    const fechaFormateada = format(fechaUTC, 'yyyy-MM-dd');

    const usuarioDto: UsuarioDto = {
      primer_nombre: formValue['primer_nombre'],
      segundo_nombre: formValue['segundo_nombre'],
      primer_apellido: formValue['primer_apellido'],
      segundo_apellido: formValue['segundo_apellido'],
      tipo_identificacion: parseInt(formValue['tipo_documento']),
      numero_identificacion: formValue['numero_documento'],
      fecha_nacimiento: fechaFormateada,
      pregunta_seguridad: formValue['pregunta_seguridad'],
      email: formValue['correo'],
      tipo_usuario: parseInt(this.tipoUsuarioForm.value.tipoUsuario),
      id_nacionalidad: parseInt(formValue['nacionalidad']),
      id_municipio: formValue['municipio'] || formValue['pais'],
      telefono_principal: formValue['telefono'],
      direccion: formValue['direccion'],
      otro_departamento: formValue['otroDepartamento'],
      otro_municipio: formValue['otroMunicipio'],
      tipoRegistro: 'registry'
    };

    return usuarioDto;
  }

  onRecaptchaResolved(token: string | null) {
    this.recaptchaToken = token;
  }

  onDocumentTypeChange(): void {
    const documentType = this.crearUsuarioForm.get('tipo_documento')?.value;
    const numDocumentoControl = this.crearUsuarioForm.get('numero_documento');
    numDocumentoControl?.setValue('');
    numDocumentoControl?.clearValidators();
    if (documentType == 4) {
      numDocumentoControl?.setValidators([
        Validators.required,
        Validators.maxLength(12),
        Validators.minLength(4)
      ]);
      this.allowedType = 'alphanumeric';
      this.maxLengthIdentificacion = 8;
    } else {
      numDocumentoControl?.setValidators([
        Validators.required,
        Validators.maxLength(12),
        Validators.minLength(4),
      ]);
      this.allowedType = 'numbers';
      this.maxLengthIdentificacion = 12;
    }
    numDocumentoControl?.updateValueAndValidity();
    this.crearUsuarioForm.get('tipo_documento')?.updateValueAndValidity();
  }

  onInputChange(
    event: any,
    maxLength: number,
    nombreInput: string,
    onlyLetters: boolean = false
  ) {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    if (value.length > maxLength) {
      value = value.slice(0, maxLength);
    }
    if (onlyLetters) {
      value = value.replace(/[^a-zA-Z\s]/g, '');
    }
    input.value = value;
    this.crearUsuarioForm.get(nombreInput)?.setValue(value);
  }

  validarAnio(event: Event) {
    const input = event.target as HTMLInputElement;
    const fechaIngresada = new Date(input.value);
    if (fechaIngresada.getFullYear() > this.anioActual) {
      fechaIngresada.setFullYear(this.anioActual);
      input.value = fechaIngresada.toISOString().split('T')[0];
      this.crearUsuarioForm.get('fecha_nacimiento')?.setValue(input.value);
    }
  }

  // Función que transforma el texto ingresado en mayúsculas
  transformToUppercase(fieldName: string): void {
    const control = this.crearUsuarioForm.get(fieldName);
    if (control && typeof control.value === 'string' && control.value.trim()) {
      const uppercasedValue = control.value.toUpperCase();
      control.setValue(uppercasedValue, { emitEvent: false });
    }
  }

  edadMinimaValidator(aniosRequeridos: number) {
    return (control: AbstractControl): ValidationErrors | null => {
      const fechaNacimiento = control.value;
      if (!fechaNacimiento) {
        return null; // No validar si no hay valor
      }

      const fechaNacimientoDate = new Date(fechaNacimiento);
      const fechaActual = new Date();

      // Cálculo exacto de la edad considerando mes y día
      let edad = fechaActual.getFullYear() - fechaNacimientoDate.getFullYear();
      const mes = fechaActual.getMonth() - fechaNacimientoDate.getMonth();
      const dia = fechaActual.getDate() - fechaNacimientoDate.getDate();

      if (mes < 0 || (mes === 0 && dia < 0)) {
        edad--; // Resta un año si aún no ha pasado su cumpleaños
      }

      return edad < aniosRequeridos ? { edadRequerida: true } : null;
    };
  }

  // Función que consume el servicio de listar departamentos de acuerdo al país seleccionado
  obtenerDepartamentos(event: any) {
    this.listasService
      .getDepartmentList(event.target.value)
      .subscribe((departamentos: DepartmentoDto[]) => {
        this.departamentos = departamentos;
        // Se verifica si el país seleccionado es Colombia, para setear las validaciones correspondientes a los campos
        const idPais = this.paises.find(
          item => item.Codigo == Constants.CODIGO_COLOMBIA
        )?.Id;
        event.target.value == idPais ? this.esColombia = true : this.esColombia = false;
        if (!this.esColombia) {
          this.crearUsuarioForm.get('departamento')?.setValue('');
          this.crearUsuarioForm.get('municipio')?.setValue('');
          this.municipios = [];
          this.setearValidadoresForm(
            this.crearUsuarioForm,
            'otroDepartamento',
            [Validators.required,
            Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
            Validators.maxLength(30)
            ]);
          this.setearValidadoresForm(
            this.crearUsuarioForm,
            'otroMunicipio',
            [Validators.required,
            Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
            Validators.maxLength(30)
            ]);
          this.setearValidadoresForm(
            this.crearUsuarioForm,
            'departamento',
            null);
          this.setearValidadoresForm(
            this.crearUsuarioForm,
            'municipio',
            null);
        } else {
          this.setearValidadoresForm(
            this.crearUsuarioForm,
            'departamento',
            [Validators.required]);
          this.setearValidadoresForm(
            this.crearUsuarioForm,
            'municipio',
            [Validators.required]);
          this.setearValidadoresForm(
            this.crearUsuarioForm,
            'otroDepartamento',
            null);
          this.setearValidadoresForm(
            this.crearUsuarioForm,
            'otroMunicipio',
            null);
        }
      });
  }

  // Función que consume el servicio de listar municipios de acuerdo al departamento seleccionado
  obtenerMunicipios(event: any) {
    this.listasService
      .getMunicipalityList(this.esColombia ? event.target.value : event)
      .subscribe((municipios: MunicipioDto[]) => {
        if (!this.esColombia) {
          this.crearUsuarioForm.get('municipio')?.setValue('');
          this.municipios = [];
        } else {
          this.municipios = municipios;
        }
      });
  }

  setearValidadoresForm(
    form: FormGroup,
    nombreCampo: string,
    validadores: any
  ) {
    form.controls[nombreCampo].setValidators(
      validadores
    );
    form.controls[
      nombreCampo
    ].updateValueAndValidity();
  }

  // Avanza a la sección de términos y condiciones
  goToTermsSection() {
    if (this.crearUsuarioForm.valid) {
      this.showTermsSection = true;
    } else {
      this.crearUsuarioForm.markAllAsTouched();
    }
  }

  // Registra el usuario solo si aceptó términos
  registerWithTerms() {
    if (this.acceptedPrivacy && this.acceptedTerms) {
      this.onSubmit('registry');
    }
  }

  // Vuelve al formulario desde la sección de términos
  goBackToForm() {
    this.showTermsSection = false;
  }

  getTerminosYCondiciones() {
    this.terminosCondicionesService.obtenerTerminosYCondiciones().subscribe({
      next: (response) => {
        this.terms = response;
      },
      error: (error) => {
        this.alertaModalService.error(
          'Error al cargar los términos y condiciones',
          error.message
        );
      },
    });
  }

  openPoliticaPrivacidadModal() {
    this.modalTerminos.titulo = this.terms!.politicaPrivacidad.nombre_parametro;
    this.modalTerminos.contenido = this.terms!.politicaPrivacidad.valor_parametro;
    this.modalTerminos.aceptarTerminosEmitter.pipe(take(1)).subscribe((aceptado: boolean) => {
      this.acceptedPrivacy = aceptado;
    });
    this.modalTerminos.abrirCerrarModal();
  }

  openTerminosCondicionesModal() {
    this.modalTerminos.titulo = this.terms!.terminosCondiciones.nombre_parametro;
    this.modalTerminos.contenido = this.terms!.terminosCondiciones.valor_parametro;
    this.modalTerminos.aceptarTerminosEmitter.pipe(take(1)).subscribe((aceptado: boolean) => {
      this.acceptedTerms = aceptado;
    });
    this.modalTerminos.abrirCerrarModal();
  }
}
